// University of Rochester's undergraduate majors (#2748). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Bulletin's Programs pages: the
// inventory of programs New York State has registered for the School of Arts
// & Sciences and the Hajim School (bulletin/college/programs.html) and for
// the Eastman School of Music (bulletin/esm/programs.html). Names and degree
// abbreviations are the bulletin's own, including its tracks written as
// "Biological Sciences: Biochemistry"; Geomechanics appears under both
// schools in the bulletin and is kept in both. Left out: programs whose only
// degree is a combined BS/MS or BA/MS (Biological Sciences: Neuroscience/
// Neuroscience, Environmental Health/Epidemiology, Epidemiology BA/MS,
// Statistics/Biostatistics), and the School of Nursing's list, which holds
// accelerated and RN-to-BS programs rather than a first-year entry. The
// bulletin's inventory for SAS, Hajim and Simon lists no Simon program. The
// Eastman note quotes the admissions First-Year Students page (the college
// file's `firstYear` source). The KB's majors list was the starting point;
// the bulletin wins.
const majors = {
    "slug": "university-of-rochester",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in the University of Rochester's official 2026-2027 Undergraduate Bulletin, grouped by the school that offers it, with the degree it leads to. Combined bachelor's and master's programs, nursing programs for students who already hold a degree or a nursing license, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Arts & Sciences",
            "source": {
                "label": "UR 2026-2027 Undergraduate Bulletin, SAS, Hajim, and Simon Programs",
                "url": "https://www.rochester.edu/bulletin/college/programs.html"
            },
            "majors": [
                {
                    "name": "American Sign Language",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Archaeology, Technology, and Historical Structures",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Bioethics",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Cell and Developmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Ecology and Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Molecular Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences: Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Black Studies",
                    "degree": "BA"
                },
                {
                    "name": "Brain and Cognitive Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Brain and Cognitive Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry: Biological Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry: Inorganic Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry: Organic Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry: Physical Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Classical Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Clinical and Translational Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Dance: Creative Expression and Performance",
                    "degree": "BA"
                },
                {
                    "name": "Dance: Dance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Earth, Environmental, and Planetary Science",
                    "degree": "BS"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English: British and American Literature",
                    "degree": "BA"
                },
                {
                    "name": "English: Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English: Language, Media and Communication",
                    "degree": "BA"
                },
                {
                    "name": "English: Theater",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Health",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Epidemiology",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Financial Economics",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender, Sexuality and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geomechanics",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Health Behavior and Society",
                    "degree": "BA"
                },
                {
                    "name": "Health Policy",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdepartmental Degree Program",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Medical Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Politics, Philosophy, and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Religion, Politics, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Edmund A. Hajim School of Engineering & Applied Sciences",
            "source": {
                "label": "UR 2026-2027 Undergraduate Bulletin, SAS, Hajim, and Simon Programs",
                "url": "https://www.rochester.edu/bulletin/college/programs.html"
            },
            "majors": [
                {
                    "name": "Audio and Music Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Audio Arts and Technology",
                    "degree": "BA"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS, BS/MS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS, BS/MS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering and Applied Science",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BA"
                },
                {
                    "name": "Geomechanics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Optical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Optics",
                    "degree": "BS, BS/MS"
                }
            ]
        },
        {
            "name": "Eastman School of Music",
            "source": {
                "label": "UR 2026-2027 Undergraduate Bulletin, Eastman School of Music Programs",
                "url": "https://www.rochester.edu/bulletin/esm/programs.html"
            },
            "majors": [
                {
                    "name": "Applied Music",
                    "degree": "BM"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies and Contemporary Media: Performance",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies and Contemporary Media: Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Education Birth-12",
                    "degree": "BM, Cert"
                },
                {
                    "name": "Musical Arts",
                    "degree": "BM"
                },
                {
                    "name": "Theory",
                    "degree": "BM"
                }
            ],
            "note": "For a bachelor of music at Eastman alone, you apply through the Eastman application, not the Common App or Coalition application.",
            "noteSource": "firstYear"
        }
    ]
};

export default majors;
